/*eslint-disable*/
import api from '../'

class transferSyllablesSchoolPreparingGameItems {
    // POST: couples
    static getItemsByRequest (params) {
        return api.axios.get('/transferSyllablesSchoolPreparing/items', { params }).then(response => response.data.items);
    }
}

export default transferSyllablesSchoolPreparingGameItems;
